export default "__VITE_ASSET__CmZgoLMQ__"